import Vue from 'vue';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Vuelidate from 'vuelidate';
import Meta from 'vue-meta';
import day from 'dayjs';
import duration from 'dayjs/plugin/duration';
import App from './App.vue';
import router from './router';
import store from './store';
import Message from '@/lib/base/message';
import {removeCanvasOnDestroy} from '@/lib/base/canvas.js';
import SoundService from '@/lib/base/soundService';
import '@/lib/plugins/device';
import '@/lib/plugins/locale';
import '@/lib/plugins/directives';
import delay from '@/lib/base/delay';
import {onApiError} from '@/lib/api/callApi';
import payment from '@/lib/payment/paynow';
import {stage} from '@/constant/env.js';
import getProvinceId from '@/lib/base/getProvinceId';
import i18n from '@/i18n/index.js';
import './assets/scss/theme.scss';
import '@/assets/icomoon/style.css';
import alertFunction from '@/lib/base/alertFunction.js';

require('wgo.js/wgo/wgo.js');
require('wgo.js/wgo/kifu.js');
require('wgo.js/wgo/sgfparser.js');
require('wgo.js/wgo/player.js');
require('wgo.js/wgo/basicplayer.js');
require('wgo.js/wgo/basicplayer.component.js');
require('wgo.js/wgo/basicplayer.infobox.js');
require('wgo.js/wgo/basicplayer.commentbox.js');
require('wgo.js/wgo/basicplayer.control.js');
require('wgo.js/wgo/player.editable.js');
require('wgo.js/wgo/scoremode.js');
require('wgo.js/wgo/player.permalink.js');
const isSameOrBefore = require('dayjs/plugin/isSameOrBefore');
const isSameOrAfter = require('dayjs/plugin/isSameOrAfter');
const isBetween = require('dayjs/plugin/isBetween');

Vue.config.productionTip = false;

onApiError(function (error, {apiName}) {
  if (apiName !== 'login' && error.response && error.response.status === 401) {
    Message.error('登入狀態已過期或沒有權限查看，請重新登入');
    store.dispatch('auth/logout');
  }
});

payment.setConfig({
  stage,
});

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuelidate);
Vue.use(Meta);
Vue.use(Toast);
Vue.use(VueDOMPurifyHTML);

day.extend(duration);
day.extend(isBetween);
day.extend(isSameOrBefore);
day.extend(isSameOrAfter);

/**
 * 依照 i18n locale 設定 dayjs locale
 * @param  {...any} args dayjs 原始參數
 * @returns {dayjs} dayjs 實例
 */
const dayJsInstance = (...args) => {
  const instance = day(...args);
  const originalLocaleMethod = instance.locale.bind(instance);
  instance.locale = function (locale) {
    const mappedLocale = i18n.localeMapForDayjs[locale] || locale;
    return originalLocaleMethod(mappedLocale);
  };

  return instance;
};

Vue.prototype.$day = dayJsInstance;
Vue.prototype.$dayjs = day;
Vue.prototype.$Message = Message;
Vue.prototype.$Sound = SoundService;
Vue.prototype.$alert = alertFunction;

Vue.prototype.$playSound = (...args) => {
  SoundService.playSound(...args);
  return true;
};

Vue.prototype.$t = function (key, values) {
  let result = '';
  if (this.$i18n) {
    result = this.$i18n.t(key, values);
  }
  return result;
};

Vue.prototype.$getProvinceId = getProvinceId;

Vue.mixin({
  beforeDestroy() {
    removeCanvasOnDestroy(this.$el);
  },
});

router.afterEach(async () => {
  await delay(0);
  window.scrollTo(0, 0);
  const layoutContentMain = document.querySelector('#layoutContentMain');
  layoutContentMain.scrollTo(0, 0);
  store.commit('env/setIsNotFound', false);
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
